import { DISCARDED, SKIPPED } from '@datadog/browser-core';
export function startTrackingConsentContext(hooks, trackingConsentState) {
  hooks.register(1 /* HookNames.AssembleTelemetry */, function () {
    var wasConsented = trackingConsentState.isGranted();
    if (!wasConsented) {
      return DISCARDED;
    }
    return SKIPPED;
  });
}